import { UnknownOutputParams } from 'expo-router';
import { SmartyStreetsResponseItem } from 'features/signup/helpers/smartyStreets';

export const getParam = (
  urlSearchParams: UnknownOutputParams,
  key: string,
): string | undefined => {
  return urlSearchParams[key] as string;
};

export const constructUrlWithParams = (
  baseUrl: string,
  params: Record<string, unknown>,
): string => {
  const queryString = Object.entries(params)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`,
    )
    .join('&');

  return `${baseUrl}?${queryString}`;
};

export const DATE_120_YEARS_AGO = new Date(
  new Date().setFullYear(new Date().getFullYear() - 120),
);

export const DATE_18_YEARS_AGO = new Date(
  new Date().setFullYear(new Date().getFullYear() - 18),
);

export const getAndroidKeyboardHeightOffset = (height: number): number => {
  return height < 800 ? 0 : 20;
};

export const getAddressLine = (
  suggestion: SmartyStreetsResponseItem,
): string => {
  if (!suggestion) {
    return '';
  }

  const entries =
    suggestion.entries && suggestion.entries > 1 ? `${suggestion.entries}` : '';

  return [
    suggestion.street_line ?? '',
    suggestion.secondary ?? '',
    entries,
    suggestion.city ?? '',
    suggestion.state ?? '',
    suggestion.zipcode ?? '',
  ]
    .filter(Boolean)
    .join(' ');
};
